export default __webpack_public_path__ + "28799ec59a0f03d0f94be1d92ede3075.svg";